export const DeFooter = {
  "footer": {
    "contact": "KONTAKT",
    "data": "HAFTUNGSAUSSCHLUSS",
    "faq": "F.A.Q.",
    "impress": "IMPRESSUM",
    "legal": "RECHTLICHER HINWEIS",
    "poweredBy": "powered by"
    },
}